import styled from 'styled-components';

export const SectionHeader = styled.header`
  font: 1.5em 'godofwarregular';
  color: white;
`;
